import React from "react";
import { CardsStatisticsActive } from "./widget/CardsStatisticsActive";
import { CardsStatisticsDefaulter } from "./widget/CardsStatisticsDefaulter";
import { CardsStatisticsVisitor } from "./widget/CardsStatisticsVisitor";
import { CardsStatisticsFormPaymant } from "./widget/CardsStatisticsFormPaymant";
import { CardsStatisticsGender } from "./widget/CardsStatisticsGender";

const StatisticsView: React.FC = () => {
  return (
    <>
      <div className="row w-100 p-0">
        <div className="d-flex align-items-start w-100 p-0">
          <div className="row w-100">
            <CardsStatisticsActive className="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-2" />
            <CardsStatisticsDefaulter className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 m-2" />
            <CardsStatisticsVisitor className="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-2" />
            <CardsStatisticsGender className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 m-2" />
          </div>
          <CardsStatisticsFormPaymant className="d-none d-sm-block col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 m-2" />
        </div>
      </div>
    </>
  );
};

export default StatisticsView;
